export enum ValidityStatus {
  VALID,
  INCOMPLETE,
  INVALID
}

export const validityMap: Record<ValidityStatus, string> = {
  [ValidityStatus.VALID]: 'Valid',
  [ValidityStatus.INCOMPLETE]: 'Incomplete',
  [ValidityStatus.INVALID]: 'Invalid'
};


export enum MembershipStatus {
  ACTIVE,
  FUTURE,
  PAST,
  NONE
}

export const membershipMap: Record<MembershipStatus, string> = {
  [MembershipStatus.ACTIVE]: 'Active',
  [MembershipStatus.FUTURE]: 'Future',
  [MembershipStatus.PAST]: 'Past',
  [MembershipStatus.NONE]: 'No'
}


export enum ThreeLevelScale {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

export enum AttendanceType {
  ONLINE = 'ONLINE',
  IN_PERSON = 'IN_PERSON',
  HYBRID = 'HYBRID'
}

export enum InteractionType {
  EMAIL = 'EMAIL',
  ONLINE_EVENT = 'ONLINE_EVENT',
  F2F_EVENT = 'F2F_EVENT',
  ONLINE_MEETING = 'ONLINE_MEETING',
  F2F_MEETING = 'F2F_MEETING'
}

export enum LinkedInStatus {
  NOT_SENT = 'NOT_SENT',
  INVITATION_SENT = 'INVITATION_SENT',
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NO_LINKEDIN = 'NO_LINKEDIN'
}

export enum MemberContactType {
  PRIMARY = 'PRIMARY',
  INVOICING = 'INVOICING',
  CONTRACT = 'CONTRACT'
}

export enum GovernanceType {
  BOD = 'BOD',
  SAB = 'SAB',
  GA = 'GA',
  EXECUTIVE = 'EXECUTIVE',
  NOMINATION = 'NOMINATION',
  ETHICS = 'ETHICS'
}

export enum CommunicationType {
  OPT_IN = 'Opt-in',
  OPT_OUT = 'Opt-out'
}

export enum MemberType {
  ASSOCIATE = 'ASSOCIATE',
  FULL = 'FULL'
}

export enum OngoingRelationship {
  NOT_YET = 'NOT_YET',
  QUOTATION_ONLY = 'QUOTATION_ONLY',
  YES = 'YES'
}

export enum ProjectRole {
  PARTNER = 'Partner',
  COORDINATOR = 'Coordinator',
  OTHER = 'Other'
}

export enum SupplierFeedback {
  GOOD = 'GOOD',
  AVERAGE = 'AVERAGE',
  AVOID = 'AVOID',
  NOT_YET = 'NOT_YET',
}

export enum PhoneType {
  MOBILE = 'MOBILE',
  LANDLINE = 'LANDLINE',
  FAX = 'FAX',
  OTHER = 'OTHER'
}

export enum SupplierType {
  CONTACT = 'CONTACT',
  ORGANISATION = 'ORGANISATION',
  CONTACT_IN_SUPPLIER_ORG = 'CONTACT_IN_SUPPLIER_ORG',
  NONE = 'NONE'
}

export enum MemberRecordStatus {
  ACTIVE = 'ACTIVE',
  PAST = 'PAST',
  FUTURE = 'FUTURE',
  INVALID = 'INVALID'
}


export enum HistoryUpdateType {
  // attribute updates
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  // entity updates
  CREATE = 'CREATE', // create a new entity; ex. initiative, project, ...
  DESTROY = 'DESTROY', // remove an existing entity; ex. initiative, project, ...
  ARCHIVE = 'ARCHIVE', // archive an existing entity; ex. initiative, project, ...
  UNARCHIVE = 'UNARCHIVE', // unarchive an existing entity; ex. initiative, project, ...
}

export enum HistoryEntityKey {
  PROJECT = 'PROJECT',
  EVENT = 'EVENT',
  ORGANISATION = 'ORGANISATION',
  CONTACT = 'CONTACT'
}

export enum HistoryAttributeKey {
  // PROJECT = 'PROJECT',
  PROJECT_START_DATE = 'PROJECT_START_DATE',
  PROJECT_END_DATE = 'PROJECT_END_DATE',

  // EVENT = 'EVENT',
  EVENT_NAME = 'EVENT_NAME',

  // ORGANISATION = 'ORGANISATION',
  ORGANISATION_NAME = 'ORGANISATION_NAME',
  ORGANISATION_INITIATIVE = 'ORGANISATION_INITIATIVE',
  ORGANISATION_MEMBERSHIP_INTEREST = 'ORGANISATION_MEMBERSHIP_INTEREST',

  ORGANISATION_MEMBER = 'ORGANISATION_MEMBER',
  ORGANISATION_MEMBER_WILLING_TO_RECOMMEND_EUFIC = 'ORGANISATION_MEMBER_WILLING_TO_RECOMMEND_EUFIC',
  ORGANISATION_MEMBER_TYPE = 'ORGANISATION_MEMBER_TYPE',
  ORGANISATION_MEMBER_CONTRACT_START_DATE = 'ORGANISATION_MEMBER_CONTRACT_START_DATE',
  ORGANISATION_MEMBER_CONTRACT_END_DATE = 'ORGANISATION_MEMBER_CONTRACT_END_DATE',
  ORGANISATION_MEMBER_ENGAGEMENT_LEVEL = 'ORGANISATION_MEMBER_ENGAGEMENT_LEVEL',
  ORGANISATION_MEMBER_TRIAL_START_DATE = 'ORGANISATION_MEMBER_TRIAL_START_DATE',
  ORGANISATION_MEMBER_TRIAL_END_DATE = 'ORGANISATION_MEMBER_TRIAL_END_DATE',
  ORGANISATION_MEMBER_PRIMARY_CONTACT = 'ORGANISATION_MEMBER_PRIMARY_CONTACT',
  ORGANISATION_MEMBER_INVOICING_CONTACT = 'ORGANISATION_MEMBER_INVOICING_CONTACT',
  ORGANISATION_MEMBER_CONTRACT_CONTACT = 'ORGANISATION_MEMBER_CONTRACT_CONTACT',

  // CONTACT = 'CONTACT',
  CONTACT_NAME = 'CONTACT_NAME',
  CONTACT_AFFILIATION = 'CONTACT_AFFILIATION',
  CONTACT_COMMUNICATION_TYPE_1 = 'CONTACT_COMMUNICATION_TYPE_1',
  CONTACT_COMMUNICATION_TYPE_2 = 'CONTACT_COMMUNICATION_TYPE_2',
  CONTACT_COMMUNICATION_TYPE_3 = 'CONTACT_COMMUNICATION_TYPE_3',
  CONTACT_COMMUNICATION_TYPE_4 = 'CONTACT_COMMUNICATION_TYPE_4',
  CONTACT_COMMUNICATION_TYPE_5 = 'CONTACT_COMMUNICATION_TYPE_5',

  CONTACT_PROJECT = 'CONTACT_PROJECT',
  CONTACT_INITIATIVE = 'CONTACT_INITIATIVE',
  CONTACT_SCIENTIFIC_ADVISORY_BOARD = 'CONTACT_SCIENTIFIC_ADVISORY_BOARD',
  CONTACT_BOARD_OF_DIRECTORS = 'CONTACT_BOARD_OF_DIRECTORS',
  CONTACT_GENERAL_ASSEMBLY = 'CONTACT_GENERAL_ASSEMBLY',
  CONTACT_ETHICS_COMMITTEE = 'CONTACT_ETHICS_COMMITTEE',
  CONTACT_NOMINATION_COMMITTEE = 'CONTACT_NOMINATION_COMMITTEE',
  CONTACT_EXECUTIVE_COMMITTEE = 'CONTACT_EXECUTIVE_COMMITTEE'
}

export const GovernanceCommitteeMap: Record<string, string> = {
  [HistoryAttributeKey.CONTACT_SCIENTIFIC_ADVISORY_BOARD]: 'Scientific Advisory Board',
  [HistoryAttributeKey.CONTACT_BOARD_OF_DIRECTORS]: 'Board of Directors',
  [HistoryAttributeKey.CONTACT_GENERAL_ASSEMBLY]: 'General Assembly',
  [HistoryAttributeKey.CONTACT_ETHICS_COMMITTEE]: 'Ethics Committee',
  [HistoryAttributeKey.CONTACT_NOMINATION_COMMITTEE]: 'Nomination Committee',
  [HistoryAttributeKey.CONTACT_EXECUTIVE_COMMITTEE]: 'Executive Committee'
};

export const CommunicationTypeMap: Record<string, string> = {
  [HistoryAttributeKey.CONTACT_COMMUNICATION_TYPE_1]: 'Event invitations',
  [HistoryAttributeKey.CONTACT_COMMUNICATION_TYPE_2]: 'Training opportunities',
  [HistoryAttributeKey.CONTACT_COMMUNICATION_TYPE_3]: 'Activity results and flagship initiatives',
  [HistoryAttributeKey.CONTACT_COMMUNICATION_TYPE_4]: 'Results from research studies',
  [HistoryAttributeKey.CONTACT_COMMUNICATION_TYPE_5]: 'Participation in feedback surveys'
};

